/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
  FormFieldType,
  IFormCheckbox,
  IFormValidatable,
  RequiredValidations,
} from '../typings';
import { BaseFormFieldBuilder } from '.';

type Validations = RequiredValidations<IFormCheckbox['validations']>;

export class CheckboxFormFieldBuilder
  extends BaseFormFieldBuilder<IFormCheckbox>
  implements IFormValidatable<Validations>
{
  // @ts-ignore
  private _type = FormFieldType.Checkbox as const;
  // @ts-ignore
  private _typeValue = 'boolean' as const;
  private _validations?: Validations;
  // @ts-ignore
  private _scale: IFormCheckbox['scale'] = 'medium';

  constructor() {
    super();
  }

  public value(value: boolean): this {
    this._value = value;
    return this;
  }

  public validation(value: Validations[number]): this {
    if (this._validations) {
      this._validations.push(value);
    } else {
      this._validations = [value];
    }

    return this;
  }

  public validations(value: Validations): this {
    if (this._validations) {
      this._validations.push(...value);
    } else {
      this._validations = [...value];
    }

    return this;
  }

  public scale(value: IFormCheckbox['scale']): this {
    this._scale = value;
    return this;
  }
}
